'use strict';

import React, {Component} from 'react';

// var CurveChartHighchartConsoDay =
// require('../../chart/highchart/curveChartConsoDay.jsx'),
import CurveChartHighchartConsoDay from '../../../global/chart/highchart/curveChartMultipleAxis.jsx';
import Moment from 'moment';
import $ from 'jquery';

class EnergyDataViews extends Component {

    emptyList = [];

    state = {
        //Initiate Time for the chart
        timeFrom: this.props.timeFrom,
        timeTo: this.props.timeTo,
        seriesConsoDay: '{}',
        dataset: "",
        value: "", //Value of paygo box
        listBox: this.emptyList
    }
    componentDidUpdate() {
        console.log('[DEBUG],Chart Component Did Update');
    }
    componentDidMount = () => {
        //Get Data From paygo User
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'GetList class';
        var url = "/user/paygoboxlist";
        var testTime = Moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function (result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var optionTmp = [];
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.userList.length; i += 1) {
                    optionTmp.push({id: data.userList[i].name, value: data.userList[i].name})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }
            this.setState({listBox: optionTmp});
        }.bind(this));
    }
    onChange = async(e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'card class';
        var url = "/services/data/infoSolar/asadmin?from=" + this.state.timeFrom + "&to=" + this.state.timeTo + "&agg=" + this.props.agg + "&info=" + this.props.sensor + "&boxId=" + paygoId;
        var testTime = Moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);
        try {
            let req = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                json: true
            });
            let result = await req.json();
            console.log({result});

            console.log('[INFO],  reception front des données: ');
            console.log(result);
            var dtmp = [];
            var dataset = "";
            var serieNameData = [];
            try {
                var data = result;
                console.log(data);
                for (var i = 0; i < data.meterId.length; i += 1) {
                    serieNameData.push(data.meterId[i]);
                }

                for (var i = 0; i < data.DatapointList.length; i += 1) {
                    var datePoint = Date.parse(data.DatapointList[i].ts);
                    var d = new Date();
                    var offSet = d.getTimezoneOffset();
                    for (var jj = 0; jj < data.DatapointList[i].v.length; jj++) {
                        dtmp.push([]);
                    }
                    var datalistPoint = "";
                    for (var jj = 0; jj < data.DatapointList[i].v.length; jj++) {
                        dtmp[jj].push([
                            datePoint - 1000 * 60 * offSet,
                            data.DatapointList[i].v[jj]
                            //[data.DatapointList[i].v[0],data.DatapointList[i].v[0]],
                        ]);
                        datalistPoint = datalistPoint + "," + data.DatapointList[i].v[jj]
                    }
                    var dateOfThePoint = datePoint - 1000 * 60 * offSet;
                    var datePointString = new Date(dateOfThePoint).toISOString();
                    dataset = dataset + datePointString + datalistPoint + "\n";
                }
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }
            console.log(dtmp);
            var serietmp = [];
            for (var i = 0; i < serieNameData.length; i += 1) {
                var yy = 0;
                if (serieNameData[i] == 'Panel_Voltage' || serieNameData[i] == 'Charger_Voltage') {
                    yy = 1;
                }
                if (serieNameData[i] == 'Panel_Power') {
                    yy = 0;
                }
                if (serieNameData[i] == 'System_Yield') {
                    yy = 2;
                }
                if (serieNameData[i] == 'Load_Current') {
                    yy = 3;
                }
                //If dtmp = 0 ;

                serietmp.push({
                    name: serieNameData[i],
                    data: dtmp[i]
                        ? dtmp[i]
                        : [],
                    yAxis: yy
                });
            }
            console.log("Serie received");
            console.log(serietmp);
            this.setState({
                seriesConsoDay: serietmp,
                dataset: "data:application/csv;charset=utf-8," + encodeURIComponent(dataset)
            });
        } catch (error) {
            console.log(error)
            this.notif("danger", "error func", "Erreur")
        }
    }
    componentWillUnmount() {
        this
            .serverRequest
            .abort();
    }

    render() {
        console.log('[INFO], render fonction card');
        //console.log(this.state.seriesConsoDay);
        var listBox = this.state.listBox;

        //Order by name
        listBox.sort(function (a, b) {
            if (a.value > b.value) {
                return -1;
            }
            if (a.value < b.value) {
                return 1;
            }
            return 0;
        });

        return (
            <div className="container">
                <div className="block-header">
                    <h2>Dashboard</h2>
                    {/*
                    <ul className="actions">
                        <li>
                            <a href="#">
                                <i className="zmdi zmdi-trending-up"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="zmdi zmdi-check-all"></i>
                            </a>
                        </li>
                        <li className="dropdown">
                            <a href="#" data-toggle="dropdown">
                                <i className="zmdi zmdi-more-vert"></i>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="#">Refresh</a>
                                </li>
                                <li>
                                    <a href="#">Manage Widgets</a>
                                </li>
                                <li>
                                    <a href="#">Widgets Settings</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                  */}

                </div>

                <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                    <div className="row">
                        <div className="col-sm-12 actionBar">
                            <div className="search form-group">
                                <div className="input-group">
                                    <span className="zmdi icon input-group-addon glyphicon-search"></span>

                                    <select
                                        className="search-field form-control"
                                        value={this.state.value}
                                        onChange={this.onChange}>
                                        {listBox
                                            .map(function (optionval) {
                                                return <option value={optionval.id}>{optionval.value}</option>;
                                            })
}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h2>{this.props.ChartName}
                            <small>Consommation en Watt Heure</small>
                        </h2>

                        <ul className="actions">
                            {/*
                            <li>
                                <a href="#">
                                    <i className="zmdi zmdi-refresh-alt"></i>
                                </a>
                            </li>
                          */}
                            <li>
                                <a href={this.state.dataset} download="MyJouleBox-Month-Data.csv">
                                    <i className="zmdi zmdi-download"></i>
                                </a>
                            </li>
                            {/*
                            <li className="dropdown">
                                <a href="#" data-toggle="dropdown">
                                    <i className="zmdi zmdi-more-vert"></i>
                                </a>

                                <ul className="dropdown-menu dropdown-menu-right">
                                    <li>
                                        <a href="#">Change Date Range</a>
                                    </li>
                                    <li>
                                        <a href="#">Change Graph Type</a>
                                    </li>
                                    <li>
                                        <a href="#">Other Settings</a>
                                    </li>
                                </ul>
                            </li>
*/}
                        </ul>
                    </div>

                    <div className="card-body">
                        <div className="chart-edge">
                            <div id="curved-line-chart" className="bar-chart ">
                                <CurveChartHighchartConsoDay
                                    container='chartJ'
                                    title={this.props.graphName}
                                    container='chartAn'
                                    series={this.state.seriesConsoDay}
                                    Xaxiscategories={this.state.XaxiscategoriesAnnual}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default EnergyDataViews;

//module.exports = Card;